var _path, _path2, _g, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTelegramGrayIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 9,
    viewBox: "0 0 10 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.90283 4.99938L3.72185 7.61091C3.78012 7.79646 3.99933 7.86276 4.14378 7.73845L6.59008 5.63359C6.59008 5.63359 3.99055 4.57661 3.99055 4.63426C3.99055 4.69198 2.90283 4.99938 2.90283 4.99938Z",
    fill: "#D6D6D6"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1171_3916",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 10,
    height: 9
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.444092 0.0292358H9.98752V8.2901H0.444092V0.0292358Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1171_3916)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.58982 0.049795C7.94644 0.690856 2.64193 2.83481 0.634245 3.6471C0.369148 3.7544 0.385057 4.12947 0.658074 4.21525L2.95037 4.93545L3.79026 7.46948C3.82403 7.5713 3.90934 7.63701 4.00451 7.65469C4.08176 7.66901 4.19576 5.60262 4.19576 5.60262C4.19576 5.60262 6.60553 7.36533 7.74859 8.19777C8.03022 8.40284 8.43231 8.24861 8.49907 7.90971C8.83955 6.17879 9.6909 1.85095 9.98198 0.371422C10.0257 0.148942 9.80351 -0.0335237 9.58982 0.049795Z",
    fill: "white"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.94648 7.55804C4.02296 7.57256 4.13575 5.47761 4.13575 5.47761L8.05505 1.75919C8.0816 1.73404 8.0499 1.69167 8.01874 1.71049L2.90283 4.80116L3.73438 7.37027C3.76774 7.4735 3.85219 7.54012 3.94648 7.55804Z",
    fill: "#E5E5E5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegramGrayIcon);
export default __webpack_public_path__ + "static/media/telegram-gray-icon.68500a5b95efb387700176391307c140.svg";
export { ForwardRef as ReactComponent };